import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class ConceptsModalBasicForm extends Vue {
    @Ref() readonly conceptsModalBasicForm!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.conceptsModalBasicForm.show()
    }

    hide() {
        this.conceptsModalBasicForm.hide()
    }
}
